export default __webpack_public_path__ + "static/media/110_desktop.aeea78fa.jpg";